'use strict';

class billingService {
  constructor($http) {
    this.$http = $http;
  }

  unbilled() {
    return this.$http.get(`/billing/un-billed-transactions`);
  }

  getByBill(billNumber) {
    return this.$http.get(`/billing/${billNumber}/invoices`);
  }

  getUnpaidInvoices() {
    return this.$http.get(`/billing/invoices/unpaid`);
  }

  getDcCases() {
    return this.$http.get(`/billing/dc-cases`);
  }

  getAllInvoices() {
    return this.$http.get(`/billing/invoices`);
  }

  getVippsOrders() {
    return this.$http.get(`/billing/vipps-orders`);
  }

  getSalesLedger() {
    return this.$http.get(`/billing/sales-ledger`);
  }

  settleVipps(params) {
    return this.$http.post(`/billing/settle/vipps`, params);
  }

  vippsOrderDetails(id) {
    return this.$http.get(`/billing/vipps/${id}`);
  }
}

billingService.$inject = ['$http'];

angular
  .module('SendRegning')
  .service('billingService', billingService);
